import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { DialogModalSize } from '../../components/dialog/dialog-ref';
import { ConfigureUiEngineComponent } from '../../components/ui-engine/configure-uiengine/configure-uiengine.component';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { SmartModalService } from '../../services/smart-modal.service';
import { AppService } from './app.service';
import { BaseService } from './base.service';
import { StorageService } from './storage.service';

@Injectable(
    { providedIn: 'root' }
)
export class PreferenceService {
    public config: any = { all: "all", notAllowedHeaders: [], allowedCareType: [] };
    public static TODAY: string = 'today';
    headerConfig = new Subject<boolean>();
    commonConfig: any = {};
    headerConfig$ = this.headerConfig.asObservable()
    constructor(public baseService: BaseService,
        public loader: LoaderService,
        public storageService: StorageService,
        public alerts: AlertsService,
        public appService: AppService,
        public smartModalService: SmartModalService) {
    }

    getDynamicFilterData(key, callback) {
        this.loader.showSpinner();
        let data = {
            "filter": "screenName:" + key,
            "query_id": "GET_WORKLIST_BY_USER_NAME"
        }
        this.baseService.getData(data, "", "facility_worklist_mapping", "facility-management", "GET_WORKLIST_BY_USER_NAME").subscribe(
            async (data: any) => {
                if (data.errCode == -1) {
                    callback({});
                } else {
                    if (data.resource != undefined && data.resource.length) {
                        // try {
                        let json = [];
                        await data.resource.forEach(element => {
                            let a = JSON.parse(element.json);
                            a['filter__']['subType'] = 'dynamic';
                            json.push(a['filter__']);
                        });
                        await callback(json);
                        // } catch (e) {
                        //     callback({});
                        // }
                    } else {
                        callback({});
                    }
                }
                this.loader.hideSpinner();
            }, error => {
                console.log(error);
                this.loader.hideSpinner();
                callback({})
            }
        );
    }

    getTableConfigByRequest(key, callback) {
        this.loader.showSpinner();
        var arrKey: any = key;
        if (Array.isArray(key)) {
            key = key.join("#");
        }
        this.baseService.getWithoutfacilityId("GET_USER_AND_ACCOUNT_PREFERENCE", "", "user_preference", "account-management", "name:" + key).subscribe(
            (data: any) => {
                if (data.errCode == -1) {
                    callback({});
                } else {

                    if (data.resource != undefined && data.resource.length) {
                        try {
                            if (Array.isArray(arrKey)) {
                                this.parsePreferenceRequest(arrKey, data.resource, callback);
                            } else {
                                //var json = JSON.parse(data.resource[0].json);
                                this.parsePreferenceRequest([arrKey], data.resource, callback);
                            }
                        } catch (e) {
                            this.parsePreferenceRequest(arrKey, {}, callback);
                        }
                    } else {
                        this.parsePreferenceRequest(arrKey, {}, callback);
                    }
                }
                this.loader.hideSpinner();
            }, error => {
                console.log(error);
                this.loader.hideSpinner();
                callback({})
            }
        );
    }

    parsePreferenceRequest(key, data, callback) {
        if (Array.isArray(key)) {
            var tempKey = JSON.parse(JSON.stringify(key));
            var finalData = {};
            var accountMap = {};
            for (let index = 0; index < data.length; index++) {
                let singleData = data[index];
                if (singleData.name != undefined && singleData.userId != undefined) {
                    if (singleData.userId == '0') {
                        finalData["account__" + singleData.name] = JSON.parse(singleData.json);
                        accountMap["account__" + singleData.name] = true;
                        this.storageService.setData("account__" + singleData.name, finalData["account__" + singleData.name], () => { });
                    } else {
                        finalData[singleData.name] = JSON.parse(singleData.json);
                        this.storageService.setData(singleData.name, finalData[singleData.name], () => { });
                        var i = key.indexOf(singleData.name);
                        if (i !== -1) {
                            key.splice(i, 1);
                        }
                    }

                }
            }
            for (let index = 0; index < tempKey.length; index++) {
                let singleKey = tempKey[index];
                let name = "account__" + singleKey;
                if (accountMap[name] == undefined) {
                    let dta = this.storageService.getLocalStorageDataSync(name);
                    if (!dta) {
                        this.storageService.setData(name, {}, () => { });
                    }
                }
            }
            for (let index = 0; index < key.length; index++) {
                let singleKey = key[index];
                let dta = this.storageService.getLocalStorageDataSync(singleKey);
                if (!dta) {
                    this.storageService.setData(singleKey, {}, () => { });
                }
            }
            callback(finalData);
        } else {
            this.storageService.setData(key, data, () => {
                callback(data);
            })
        }
    }

    getUserPreferenceConfig(key, callback, noCache?) {
        if (Array.isArray(key)) {
            var allPromiseObj = [];
            var resultMap = {};
            var tempKey = JSON.parse(JSON.stringify(key));
            for (let index = 0; index < tempKey.length; index++) {
                let singleKey = tempKey[index];
                key.push("account__" + singleKey);
            }
            if (!noCache) {
                for (let index = 0; index < key.length; index++) {
                    let singleKey = key[index];
                    allPromiseObj.push(new Promise((resolve, reject) => {
                        this.storageService.getData(singleKey, (data) => {
                            resolve(data);
                        })
                    }));
                }
            }

            var singleNotFound = false;
            Promise.all(allPromiseObj).then((promiseResponse) => {
                for (let index = 0; index < promiseResponse.length; index++) {
                    let singleResponse = promiseResponse[index];
                    if (!singleResponse) {
                        singleNotFound = true;
                    } else {

                    }
                    resultMap[key[index]] = singleResponse;
                }
                if (noCache) {
                    singleNotFound = true;
                }
                if (singleNotFound) {
                    this.getTableConfigByRequest(tempKey, callback);
                } else {
                    callback(resultMap);
                }
            });
        } else {
            if (!noCache) {
                this.storageService.getData(key, (data) => {
                    if (data) {
                        callback(data);
                    } else {
                        this.getTableConfigByRequest(key, callback);
                    }
                })
            } else {
                this.getTableConfigByRequest(key, callback);
            }
        }

    }

    getBannerPreference(config, jsonName, callback, jsonFields: any = []) {
        var key = this.getBannerPreferenceKey(jsonName);
        this.getUserPreferenceConfig([key], (data) => {
            if (data["account__" + key] != undefined && Object.keys(data["account__" + key]).length > 0) {
                var afterConfig = this.applyJsonConfig({ config: config, resouceDef: { list: { fields: jsonFields } } }, data["account__" + key]);
            } else {
                var afterConfig = this.applyJsonConfig({ headers: config }, []);
            }
            callback();
        });
    }

    getBannerPreferenceKey(jsonName) {
        return jsonName + '_list_config';
    }

    getConfigurationKey(resourceName) {
        var saveKey = "account__" + resourceName + '_list_config';
        return saveKey;;
    }

    saveTableConfigData(key, data, callback: any = false) {
        this.storageService.setData(key, data, () => {
            this.baseService.action({ name: key, json: JSON.stringify(data) }, "UPDATE_USER", "account-management", "user_preference").subscribe(
                (data: any) => {
                    if (callback && typeof callback == 'function') {
                        callback();
                    }
                }, error => {
                    if (callback) {
                        callback();
                    }
                    console.log(error);
                }
            )
        });
    }

    saveRoleConfigData(key, role, data, callback: any = false) {
        this.storageService.setData(key, data, () => {
            this.baseService.action({ name: key, role: role, json: JSON.stringify(data) }, "UPDATE_USER", "account-management", "user_preference").subscribe(
                (data: any) => {
                    if (callback) {
                        callback();
                    }
                }, error => {
                    if (callback) {
                        callback();
                    }
                    console.log(error);
                }
            )
        });
    }

    delteConfigData(key, callback) {
        this.storageService.removeData(key, () => {
            this.baseService.action({ name: key }, "DELETE_BY_NAME", "account-management", "user_preference").subscribe(
                (data: any) => {
                    callback()
                }, error => {
                    callback()
                    console.log(error);
                }
            )

        });
    }

    openConfigurePopup(obj, callback) {
        this.baseService.getResourceDef(obj["resource_name"], (resourceDef) => {
            if (obj?.dynamic_conf_columns?.length > 0)
                resourceDef.list.fields = resourceDef.list.fields.concat(obj.dynamic_conf_columns);
            this.openPopUp(obj, resourceDef, callback);
        });
    }

    openPopUp(obj, resourceDef, callback) {
        obj["resourceDef"] = resourceDef;
        this.getConfigurationData(obj, (data) => {
            obj["data"] = (data) ? data : {};
            this.smartModalService.open(ConfigureUiEngineComponent, obj, "", DialogModalSize.Lg).subscribe(
                response => {
                    callback(response);
                }, err => { }
            );
        });
    }

    getConfigurationData(obj, callback) {
        if (obj["key"] != undefined) {
            this.storageService.getData(obj["key"], (data) => {
                callback(data);
            })
        }
        return {};
    }

    saveConfigurationData(obj, data, callback, saveInitialFilter?) {
        if (obj["key"] != undefined && data) {
            var name = obj["key"].replace("account__", "");
            this.baseService.action({ name: name, json: JSON.stringify(data) }, "UPDATE_ACCOUNT_SETTINGS", "account-management", "user_preference").subscribe(
                (response: any) => {
                    if (response.errCode == -1) {
                        this.alerts.error(response.message);
                    } else {
                        if (saveInitialFilter != undefined && saveInitialFilter) {
                            this.storageService.setData(obj["key"], saveInitialFilter, (res) => {
                                callback(res);
                            })
                        } else {
                            this.storageService.setData(obj["key"], data, (res) => {
                                callback(res);
                            })
                        }

                    }

                }, error => {
                    this.storageService.setData(obj["key"], {}, (res) => {
                        callback(res);
                    })
                    console.error(error);
                }
            )

        }
        return {};
    }

    applyJsonConfig(resourceDef, config) {
        var allConfigKeys = this.getConfigFields();
        var allConfigFuncs = this.getConfigFunctions();
        var userGroup = this.appService.getCurrentUserGroup();
        for (let m in allConfigKeys) {
            if (allConfigFuncs[m] != undefined) {
                if (config[m] != undefined && config[m][this.config.all] != undefined) {
                    allConfigFuncs[m].apply(this, [resourceDef, config[m][this.config.all]]);
                }
                if (config[m] != undefined && config[m][userGroup] != undefined) {
                    allConfigFuncs[m].apply(this, [resourceDef, config[m][userGroup]]);
                }
            }

        }

        return resourceDef;
    }

    orderColumns(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0 && resourceDef.list != undefined && resourceDef.list.fields != undefined && Array.isArray(resourceDef.list.fields) && resourceDef.list.fields.length > 0) {
            for (let i = resourceDef.list.fields.length - 1; i >= 0; i--) {
                var list = resourceDef.list.fields[i];
                if (list.name != undefined) {
                    var col = arr.find(({ id }) => id == list.name);
                    if (col && col.id != undefined && col.o != undefined) {
                        list.order = col.o;
                    }
                }

            }
            let dynamic_colums = arr.filter(col => resourceDef.list.fields.find(fld => fld.name == col.id) == undefined);//filtering out dynamic columns from the columns list to apply order on dynamic columns
            if (Array.isArray(arr) && arr.length > 0 && dynamic_colums && Array.isArray(dynamic_colums) && dynamic_colums.length > 0) {
                for (let i = dynamic_colums.length - 1; i >= 0; i--) {
                    var list = dynamic_colums[i];
                    if (list.name != undefined) {
                        var col = arr.find(({ id }) => id == list.name);
                        if (col && col.id != undefined && col.o != undefined) {
                            list.order = col.o;
                        }
                    }
                }
                resourceDef.list['dynamic_columns'] = dynamic_colums;
            }
        }

    }

    orderTabs(resourceDef, arr) {
        if (resourceDef.layout != undefined) {
            var layouts = resourceDef.layout;
            if (Array.isArray(arr) && arr.length > 0) {
                var i = 1;
                for (let l in layouts) {
                    if (layouts[l]["data"] != undefined && layouts[l]["data"]["id"] != undefined) {
                        layouts[l]["data"]["order"] = i;
                        var col = arr.find(({ id }) => id == layouts[l]["data"]["id"]);
                        if (col && col.id != undefined && col.o != undefined) {
                            layouts[l]["data"]["order"] = col.o;
                        }
                        i++;
                    }
                }
            }
        }
    }



    removeColumns(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0) {
            if (resourceDef.list != undefined) {
                this.removeFields(resourceDef.list.fields, arr);
            }
            /************ FOR CARD  ********************/
            if (resourceDef.card != undefined && resourceDef.card.blocks != undefined) {
                if (resourceDef.card.blocks.header != undefined) {
                    this.removeFields(resourceDef.card.blocks.header.fields, arr);
                }
                if (resourceDef.card.blocks.body != undefined) {
                    this.removeFields(resourceDef.card.blocks.body.fields, arr);
                }
                if (resourceDef.card.blocks.footer != undefined) {
                    this.removeFields(resourceDef.card.blocks.footer.fields, arr);
                }
            }
            /************ FOR CARD  ********************/

        }
    }

    removeFields(fields, arr) {
        if (Array.isArray(arr) && arr.length > 0 && Array.isArray(fields) && fields.length > 0) {
            for (let i = fields.length - 1; i >= 0; i--) {
                var list = fields[i];
                if (arr.indexOf(list.name) > -1) {
                    fields.splice(i, 1);
                }
            }
        }
    }

    removeActions(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0) {
            if (resourceDef.capability != undefined) {
                this.removeButtons(resourceDef.capability, arr);
            }
            /************ FOR CARD  ********************/
            if (resourceDef.card != undefined && resourceDef.card.blocks != undefined) {
                if (resourceDef.card.blocks.footer != undefined && resourceDef.card.blocks.footer != undefined && resourceDef.card.blocks.footer.actions != undefined) {
                    this.removeButtons(resourceDef.card.blocks.footer.actions.buttons, arr);
                }
            }
            /************ FOR CARD  ********************/

        }

        var actionsMap = ['download', 'print'];
        const found = arr.some(r => actionsMap.indexOf(r) >= 0)
        if (Array.isArray(arr) && arr.length > 0 && found) {
            if (resourceDef.list == undefined) {
                resourceDef.list = {};
            }
            if (resourceDef.list.print_allowed == undefined) {
                resourceDef.list.print_allowed = [];
            }
            if (resourceDef.list.print_allowed.indexOf('refresh') == -1) {
                resourceDef.list.print_allowed.push('refresh');
            }
            for (let index = 0; index < actionsMap.length; index++) {
                let cap: string = actionsMap[index];
                if (arr.indexOf(cap) == -1) {
                    resourceDef.list.print_allowed.push(cap);
                } else {
                    if (resourceDef.list.printActions != undefined) {
                        delete resourceDef.list.printActions;//removing print actions if anydownload or print is removed fromconfigure grid 
                    }
                }
            }
        }
        const foundC = arr.some(r => ['configure_grid'].indexOf(r) >= 0);
        if (resourceDef.config == undefined) {
            resourceDef.config = {};
        }
        if (foundC) {
            resourceDef.config.configure_grid = false;
        } else {
            resourceDef.config.configure_grid = true;
        }
        if (resourceDef.config.master_upload != undefined) {
            const foundM = arr.some(r => ['master_upload'].indexOf(r) >= 0);
            if (foundM) {
                resourceDef.config.master_upload = false;
            }
        }
    }
    removeEgAction(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0) {
            if (resourceDef.list != undefined && resourceDef.list.actions != undefined && resourceDef.list.actions.length > 0 && resourceDef.list.actions[0].conditions != undefined && Array.isArray(resourceDef.list.actions[0].conditions) && resourceDef.list.actions[0].conditions.length > 0) {
                for (let index = resourceDef.list.actions[0].conditions.length - 1; index >= 0; index--) {
                    var actionObj = resourceDef.list.actions[0].conditions[index];
                    for (let i = 0; i < arr.length; i++) {
                        let act = arr[i];
                        if (actionObj[act] != undefined) {
                            resourceDef.list.actions[0].conditions.splice(index, 1)
                        }
                    }
                }
            }
        }

    }

    removeButtons(capability, arr) {
        if (Array.isArray(capability) && capability.length > 0) {
            for (let i = capability.length - 1; i >= 0; i--) {
                var cap = capability[i];
                var action = cap.action_name || cap.action;
                if (arr.indexOf(action) > -1) {
                    capability.splice(i, 1);
                }
            }
        }
    }

    removeFilters(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0 && resourceDef.list != undefined && resourceDef.list.filter != undefined && resourceDef.list.filter.blocks != undefined && Array.isArray(resourceDef.list.filter.blocks) && resourceDef.list.filter.blocks.length > 0) {
            //TODO we have not written here code for block inside block because for now it is not being used anywhere
            for (let i = resourceDef.list.filter.blocks.length - 1; i >= 0; i--) {
                var block = resourceDef.list.filter.blocks[i];
                if (block.fields != undefined) {
                    for (let j = block.fields.length - 1; j >= 0; j--) {
                        var field = block.fields[j];
                        if (arr.indexOf(field.name) > -1) {
                            block.fields.splice(j, 1);
                        }
                    }
                }

            }
        }

    }

    applyDefaultFilter(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        var defFilters = [];
        if (Array.isArray(arr) && arr.length > 0 && resourceDef.list != undefined && resourceDef.list.filter != undefined && resourceDef.list.filter.blocks != undefined && Array.isArray(resourceDef.list.filter.blocks) && resourceDef.list.filter.blocks.length > 0) {
            //TODO we have not written here code for block inside block because for now it is not being used anywhere
            var supportedInputs = this.getSupportedInptus();
            for (let i = resourceDef.list.filter.blocks.length - 1; i >= 0; i--) {
                var block = resourceDef.list.filter.blocks[i];
                if (block.fields != undefined) {
                    for (let j = block.fields.length - 1; j >= 0; j--) {
                        var filter = block.fields[j];
                        if (filter.name != undefined) {
                            var col = arr.find(({ id }) => id == filter.name);
                            if (col && col.id != undefined && supportedInputs.indexOf(filter["component"]) > -1) {
                                switch (filter["component"]) {
                                    case supportedInputs[0]:
                                        //currently we only support today in value because daterange picker does not support any other than today
                                        if (col["v"] != undefined && col["v"] == PreferenceService.TODAY) {
                                            filter["selected"] = true;
                                            delete filter["randomSelection"];
                                        } else if (col["v"] != undefined && col["v"]) {
                                            filter["randomSelection"] = col["v"];
                                            delete filter["selected"];
                                            resourceDef.list.filter.default_filter = true; // it sends configured default filter in first api call also otherwise we had to click "apply" on filter for it to be effective.
                                        } else {
                                            delete filter["selected"];
                                        }
                                        break;
                                    case supportedInputs[1]:
                                        if (filter["defaultsetting"] == undefined) {
                                            filter["defaultsetting"] = {};
                                        }
                                        if (filter.getterValue != undefined) {
                                            filter["defaultsetting"]["setDefaultValToCheck"] = filter.getterValue;
                                        } else {
                                            filter["defaultsetting"]["setDefaultValToCheck"] = col.id;
                                        }

                                        filter["defaultsetting"]["setDefaultVal"] = col.v;
                                        filter["Value"] = col.v;
                                        filter["default"] = col.v;
                                        if (filter["defaultsetting"]["apliCall"]) {
                                            filter["defaultsetting"]["defaultData"] = true;
                                            filter["defaultsetting"]["setApiCallDefault"] = true;
                                        }
                                        defFilters.push(col.id);
                                        break;
                                    case supportedInputs[2]:
                                        filter["defaultValue"] = col.v;
                                        filter["default"] = col.v;
                                        defFilters.push(col.id);
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                }

            }
            if (defFilters.length > 0) {
                resourceDef.list["defFilters"] = defFilters;
            }
        }

    }
    addDefaultSearchs(allData, arr) {
        return this.addDefaultComplexSearchs("list", allData, arr);
    }
    addDefaultAddSearchBtn(allData, arr) {
        return this.addDefaultComplexSearchs("addButton", allData, arr);
    }
    addDefaultComplexSearchs(key, allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0 && resourceDef[key] != undefined && resourceDef[key].complex_search != undefined && Array.isArray(resourceDef[key].complex_search) && resourceDef[key].complex_search.length > 0) {
            var defaultFound: any = false;
            for (let i = resourceDef[key].complex_search.length - 1; i >= 0; i--) {
                var search = resourceDef[key].complex_search[i];
                if (arr.indexOf(search.key) > -1) {
                    defaultFound = search;
                    resourceDef[key].complex_search.splice(i, 1);
                }
            }
            if (defaultFound) {
                resourceDef[key].complex_search.unshift(defaultFound);
            }
        }
    }

    removeTabs(resourceDef, arr) {
        if (resourceDef.layout != undefined) {
            var layouts = resourceDef.layout;
            if (Array.isArray(arr) && arr.length > 0) {
                for (let index = 0; index < arr.length; index++) {
                    var toBeRemovedTab = arr[index];
                    delete layouts[toBeRemovedTab];
                }
            }
        }
    }

    getConfigFields() {
        return {
            fields: "allFields", actions: "allActions",
            tabs: "allTabs", filters: "allFilters",
            def_filters: "allDefaultFilters", searchs: "allSearchs",
            orders: "allOrders", tab_orders: "allTabOrders",
            cap_orders: "allCapOrders", menus: "allMenus",
            menu_orders: "allMenuOrders", add_btn: "allAddBtns",
            headers: "allHeaders", careTypes: "allCareTypes",
            eg_caps: "allEgCaps", banner_actions: "allBannerActions",
            confirm_actions: "confirm_actions", def_complex_value: "defComplexSearchValue",
            sort_allowed: "sortAllowed", def_add_prefix: "defAddPrefix",
            dwn_all_interval: "dwnAllInterval", summary_def: "summaryDef", config_def: "configDef",
            summary_sequence: "summarySequence", fields_currency_config: "fieldCurrencyConfig",
            summary_currency_config: "summaryCurrencyConfig",
            comma_seprated_fields: "allCommaSeprated"
        };
    }

    getConfigFunctions() {
        return {
            fields: this.removeColumns,
            tabs: this.removeTabs, actions: this.removeActions,
            filters: this.removeFilters,
            searchs: this.addDefaultSearchs, orders: this.orderColumns,
            tab_orders: this.orderTabs, def_filters: this.applyDefaultFilter,
            cap_orders: this.orderActions, menus: this.removeMenus, menu_orders: this.orderMenus,
            add_btn: this.addDefaultAddSearchBtn, headers: this.filterHeadersComponent,
            careTypes: this.applyCareType, eg_caps: this.removeEgAction,
            banner_actions: this.removeBannerActions, confirm_actions: this.confirm_actions, def_complex_value: this.addDefComplexSearchValue,
            sort_allowed: this.addSorting, def_add_prefix: this.addDefAddPrefix, dwn_all_interval: this.applyDwnInterval,
            summary_def: this.applySummaryDef, config_def: this.applyConfigDef,
            summary_sequence: this.applySummarySequence, summary_currency_config: this.getsummaryCurrencyConfig,
            fields_currency_config: this.getFieldsCurrencyConfig, comma_seprated_fields: this.getCommaSepratedConfig
        };
    }

    getsummaryCurrencyConfig(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        resourceDef["currency_type"] = arr;
    }

    applyDwnInterval(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (resourceDef.config == undefined) {
            resourceDef.config = {};
        }
        if (resourceDef.config.downloadAll == undefined) {
            resourceDef.config.downloadAll = {};
        }
        if (arr && Array.isArray(arr) && arr.length > 0) {
            resourceDef.config.downloadAll.interval = arr[0]
        }
    }

    getFieldsCurrencyConfig(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0 && resourceDef.list != undefined && resourceDef.list.fields != undefined && Array.isArray(resourceDef.list.fields) && resourceDef.list.fields.length > 0) {
            for (let i = resourceDef.list.fields.length - 1; i >= 0; i--) {
                var list = resourceDef.list.fields[i];
                if (list.name != undefined) {
                    var col = arr.find(({ id }) => id == list.name);
                    if (col && col.id != undefined && col.v != undefined) {
                        list.currency_type = col.v;
                    } else {
                        list.currency_type = false;
                    }
                }

            }
        }
    }

    getCommaSepratedConfig(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0 && resourceDef.list != undefined && resourceDef.list.fields != undefined && Array.isArray(resourceDef.list.fields) && resourceDef.list.fields.length > 0) {
            for (let i = resourceDef.list.fields.length - 1; i >= 0; i--) {
                var list = resourceDef.list.fields[i];
                if (list.name != undefined) {
                    var col = arr.find(({ id }) => id == list.name);
                    if (col && col.id != undefined && col.v != undefined) {
                        list.commaDisable = false;
                    } else {
                        list.commaDisable = true;
                    }
                }

            }
        }
    }

    applyConfigDef(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (!resourceDef.list && !resourceDef.list?.fields && resourceDef.list?.fields?.length == 0) {
            resourceDef.list.fields = [];
        }
        if (arr && Array.isArray(arr) && arr.length > 0 && resourceDef.list) {
            let _resource = resourceDef.list.fields.map((field) => {
                return {
                    ...field,
                    right_align_number: arr.filter(x => x == "right_align_number").length ? true : false,
                    center_align_number: arr.filter(x => x == "center_align_number").length ? true : false,
                    right_align_alphabetic: arr.filter(x => x == "right_align_alphabetic").length ? true : false,
                    center_align_alphabetic: arr.filter(x => x == "center_align_alphabetic").length ? true : false
                }
            });
            resourceDef.list.fields = _resource;
        }
        // console.log("resourceDef", resourceDef);
    }

    applySummaryDef(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        resourceDef["summaryinvisibleFields"] = arr;
    }
    applySummarySequence(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        resourceDef["summarySequence"] = arr;
    }

    getSummaryFields(summary: any) {
        console.log("summary", summary);
        let summaryArr = [];
        if (summary.key && summary.key.hasOwnProperty('dynamic_keys') && summary.data && summary.data.length > 0) {
            Object.keys(summary.data[0][summary.key.dynamic_keys]).forEach((elem: any, index) => {
                let obj = {};
                obj["heading"] = elem;
                obj["name"] = elem;
                obj["order"] = index + 1;
                summaryArr.push(obj);
            })
        } else if (summary && summary.data && summary.data[0] && typeof (summary.data[0]) == 'object' && !Array.isArray(summary.data[0]) && !summary.key.type) {
            let resp = summary.data[0];
            Object.keys(resp).forEach(function (key, index) {
                let obj = {};
                if (summary.key && summary.key.keys && summary.key.keys[0] && !summary.key.keys[0].hasOwnProperty(key)) {
                    if (!Object.keys(summary.key.keys[0]).map(x => summary.key.keys[0][x]).includes(key)) return
                }
                obj['heading'] = summary.key && summary.key.keys && summary.key.keys[0] ? Object.keys(summary.key.keys[0]).map(x => { return { [summary.key.keys[0][x]]: x } }).find(x => x[key])[key]
                    || key : key;
                obj['name'] = key;
                obj["order"] = index + 1;
                summaryArr.push(obj);
            });
        } else if (summary.key && (summary.key.type == "multiple_array" || summary.key.type == "multiple")) {
            // type
            summary.data.forEach((elem: any) => {
                elem[summary.key.mapKey].forEach((e: any, i: any) => {
                    let obj = {};
                    obj["heading"] = elem[summary.key.headerKey] + " || " + e["key"]
                    obj["name"] = elem[summary.key.headerKey] + "_" + e["key"];
                    obj["order"] = i + 1;
                    summaryArr.push(obj);
                })
            })
        } else if (summary && summary.key && summary.key.type == 'key_value') {
            summary.data.forEach((elem: any, i: any) => {
                let obj = {};
                obj["heading"] = elem[summary.key.key];
                obj["name"] = elem[summary.key.key];
                obj["order"] = i + 1;
                summaryArr.push(obj);
            })
        }
        return summaryArr;
    }

    addSorting(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (resourceDef.list == undefined) {
            resourceDef.list = {};
        }
        if (resourceDef.list.APIresource == undefined) {
            resourceDef.list.APIresource = {};
        }
        if (resourceDef.list.APIresource.datasource == undefined) {
            resourceDef.list.APIresource.datasource = {};
        }
        if (arr != undefined && Array.isArray(arr) && arr.length > 0) {
            if (resourceDef.list.APIresource.datasource.sortData != undefined && resourceDef.list.APIresource.datasource.sortData)
                resourceDef.list.APIresource.datasource.sortData = arr[0];
            else
                resourceDef.list.APIresource.datasource.order_by = arr[0];
        }
    }
    addDefComplexSearchValue(allData, arr) {
        this.addDefPrefix("list", allData, arr);
    }
    addDefAddPrefix(allData, arr) {
        this.addDefPrefix("addButton", allData, arr);
    }

    addDefPrefix(key, allData, arr) {

        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0 && resourceDef[key] != undefined && resourceDef[key].complex_search != undefined && Array.isArray(resourceDef[key].complex_search) && resourceDef[key].complex_search.length > 0) {

            for (let i = resourceDef[key].complex_search.length - 1; i >= 0; i--) {
                var search = resourceDef[key].complex_search[i];
                let res: any = arr.filter(item => item.id.includes(search.key));
                if (res.length > 0) {
                    try {

                        if (res[0].v && res[0].v.startsWith("{")) {
                            let prefObj = JSON.parse(res[0].v);
                            if (prefObj?.prefix) {
                                search.value = prefObj?.prefix;
                            }
                            if (prefObj?.search_length) {
                                search.search_length = prefObj?.search_length;
                            }
                        } else {
                            search.value = res[0].v;
                        }

                    } catch (e) {
                        search.value = res[0].v;
                    }

                }
            }
        }
    }



    removeBannerActions(resourceDef, arr) {
        var notAllowedActions = resourceDef.config.notAllowedActions;
        if (Array.isArray(arr) && arr.length > 0) {
            notAllowedActions = notAllowedActions.concat(arr);
        }
        resourceDef.config.notAllowedActions = [...new Set(notAllowedActions)];
    }

    //this works to bypass confirm action
    confirm_actions(resourceDef, arr) {
        try {
            if (resourceDef.resouceDef != undefined && resourceDef.resouceDef.capability != undefined && resourceDef.resouceDef.capability.length != undefined && resourceDef.resouceDef.capability.length > 0 && arr && arr.length > 0) {
                for (let item of arr) {
                    //this works for three dots capability
                    // let capability = resourceDef.resouceDef.capability.find(key => ((key.action_name == item) && (key.action == 'confirm')));
                    for (let currentCapability of resourceDef.resouceDef.capability) {
                        if ((currentCapability.action_name == item) && (currentCapability.action == 'confirm')) {
                            currentCapability['action'] = "direct_request";
                        }
                    }
                    //here we are checking if we found same action in gridbuttons then we will remove the same
                    if (resourceDef.resouceDef.list != undefined && resourceDef.resouceDef.list.gridButtons != undefined && resourceDef.resouceDef.list.gridButtons.buttonList != undefined && resourceDef.resouceDef.list.gridButtons.buttonList.length != undefined) {
                        let capability_btn = resourceDef.resouceDef.list.gridButtons.buttonList.find(key => ((key.action_name == item) && (key.action == 'confirm')));
                        if (capability_btn != undefined) {
                            capability_btn['action'] = "direct_request";
                        }
                    }


                }
            }
            //for card json
            try {
                if (resourceDef.resouceDef.card != undefined && resourceDef.resouceDef.card.blocks != undefined && resourceDef.resouceDef.card.blocks.footer.actions != undefined && resourceDef.resouceDef.card.blocks.footer.actions != undefined && resourceDef.resouceDef.card.blocks.footer.actions.buttons) {
                    for (let item of arr) {
                        let capability_btn = resourceDef.resouceDef.card.blocks.footer.actions.buttons.find(key => ((key.action_name == item) && (key.action == 'confirm')));
                        if (capability_btn != undefined) {
                            capability_btn['action'] = "direct_request";
                        }
                    }
                }
            } catch (error) { }


        } catch (error) {

        }

        // debugger;
    }

    removeMenus(resourceDef, arr) {
        if (resourceDef.menus != undefined && arr && arr.length > 0) {
            this.loopMenuReverse(this.appService._currentSessionData.menuList, 0, { delete: true, menus: arr });
            this.config.menuConfigApplied = true;
        }
    }

    orderMenus(resourceDef, arr) {
        if (resourceDef.menus != undefined && arr && arr.length > 0) {
            this.loopMenuReverse(this.appService._currentSessionData.menuList, 0, { order: true, menus: arr });
        }
    }


    getSupportedInptus() {
        return ["daterangepicker", "searchselect", "dropdown"];
    }
    orderActions(allData, arr) {
        var resourceDef: any = {};
        if (allData.resouceDef != undefined) {
            resourceDef = allData.resouceDef;
        }
        if (Array.isArray(arr) && arr.length > 0) {
            if (resourceDef.capability != undefined && resourceDef.capability.length > 0) {
                this.orderButtons(resourceDef.capability, arr);
                resourceDef.capability = resourceDef.capability.sort((a, b) => { return a.order - b.order });
            }
            /************ FOR CARD  ********************/
            if (resourceDef.card != undefined && resourceDef.card.blocks != undefined) {
                if (resourceDef.card.blocks.footer != undefined && resourceDef.card.blocks.footer != undefined && resourceDef.card.blocks.footer.actions != undefined) {
                    this.orderButtons(resourceDef.card.blocks.footer.actions.buttons, arr);
                    resourceDef.card.blocks.footer.actions.buttons = resourceDef.card.blocks.footer.actions.buttons.sort((a, b) => { return a.order - b.order });
                }
            }
            /************ FOR CARD  ********************/

        }
    }

    orderButtons(capability, arr) {
        if (Array.isArray(arr) && arr.length > 0) {
            var index = 1;
            for (let i = capability.length - 1; i >= 0; i--) {
                var cap = capability[i];
                var action = cap.action_name || cap.action;
                if (action != undefined) {
                    cap["order"] = index;
                    var col = arr.find(({ id }) => id == action);
                    if (col && col.id != undefined && col.o != undefined) {
                        capability[i]["order"] = col.o;
                    }
                    index++;
                }
            }
        }
    }

    checkCatalagueConfigExists(config, cb) {

        if (this.appService.checkArchiveCatalagueExists(config.archiveConfig.catalogue_code)) {
            config.archiveConfig.list = this.appService.getArchiveCatalague(config.archiveConfig.catalogue_code)
            cb({ 'loadArchiveConfig': { "list": config.archiveConfig.list } });
            return;
        }
        var dbTypeMap = { "clickhouse": 14, "mongodb": 4, "mysql": 1 }
        this.loader.showSpinner();
        this.baseService.get("GET_PAGE", "", "db_migration_master", "data-onboarding", "catalogue_code:" + config.archiveConfig.catalogue_code).subscribe(
            res => {
                this.loader.hideSpinner();
                if (res.errCode == 0 && res.resource && res.resource.length > 0) {
                    if (config.archiveConfig != undefined && config.archiveConfig.list != undefined) {

                    } else {
                        config.archiveConfig.list = [{
                            "label": "cur_data",
                            "id": "default",
                            "apply_on_summary": true
                        }]
                    }
                    for (let index = 0; index < res.resource.length; index++) {
                        const element = res.resource[index];
                        var id = "default";
                        if (["kxhims", "mis_kxhims"].indexOf(element.db) == -1) {
                            id = element.bucket_name;
                        }
                        let objEle: any = {
                            "forceEndOfDay": true,
                            "apply_on_summary": true,
                            "label": element.name,
                            "id": id
                        };
                        if (element.collection_name != undefined && element.collection_name != "") {
                            objEle.collection = element.collection_name
                        }
                        if (element.json_name != undefined && element.json_name != "") {
                            objEle.resource = element.json_name
                        }
                        if (element.db_type != undefined && element.db_type != "") {
                            objEle.db_type = dbTypeMap[element.db_type]
                        }
                        config.archiveConfig.list.push(objEle);
                    }

                    this.appService.setArchiveCatalagueList(config.archiveConfig.catalogue_code, config.archiveConfig.list);
                    cb({ 'loadArchiveConfig': { "list": config.archiveConfig.list } });
                } else {
                    cb(false)
                }
            },
        )
    }

    loadInitalConfig(that: any, resourceName, callback) {
        that._currentData.preferenceData = {};
        if (resourceName) {
            var saveKey: any = resourceName + '_list_config';
            var key: any = [saveKey];
            if (that._layout != undefined && that._layout == 'tab' && resourceName != that._currentData.json) {
                key.push(that._currentData.json + '_list_config');
            }
            this.getUserPreferenceConfig(key, (initalPrefData) => {
                var saveData = {};
                if (initalPrefData[saveKey] != undefined) {
                    saveData = initalPrefData[saveKey];
                }

                var keyName = resourceName + '_list_config';
                if (initalPrefData[keyName] != undefined) {
                    that._currentData.preferenceData = initalPrefData[keyName];
                }

                if (saveData && saveData['sort_']) {
                    that._currentData.sorting_persisted = saveData['sort_'];

                    // if (saveData['sort_'].value === 'asc') {
                    //   this._currentData.sortValue = 1;
                    // } else if (saveData['sort_'].value === 'desc') {
                    //   this._currentData.sortValue = -1;
                    // }
                    // this.currentSort.set(saveData['sort_'].key, sortValue);
                    // this.onSortChanges.emit(saveData['sort_']);
                } else {
                    that._currentData.sorting_persisted = undefined;
                }
                that.storageService.getDataString(saveKey + "__limit", (limit) => {
                    if (limit && that?._currentData?.gridData) {
                        that._currentData.gridData.page_size = limit;
                    } else {
                        if (saveData && saveData['limit_'] && that?._currentData?.gridData) {
                            that._currentData.gridData.page_size = saveData['limit_'];
                        }
                    }

                    if (that._layout != undefined && that._layout == 'tab') {
                        var keyName = "account__" + that._currentData.json + '_list_config';
                        that._currentData.uiConfigData = {};
                        if (initalPrefData[keyName] != undefined) {
                            that._currentData.uiConfigData = initalPrefData[keyName];
                        }
                        if (resourceName != that._currentData.json) {
                            keyName = "account__" + resourceName + '_list_config';
                            if (initalPrefData[keyName] != undefined) {
                                that._currentData.uiConfigData = { ...that._currentData.uiConfigData, ...initalPrefData[keyName] };
                            }
                        }
                    } else {
                        var keyName = "account__" + that._currentData.json + '_list_config';
                        that._currentData.uiConfigData = {};
                        if (initalPrefData[keyName] != undefined) {
                            that._currentData.uiConfigData = initalPrefData[keyName];
                        }
                    }
                    callback();
                });
            });
        } else {
            callback();
        }

    }

    addActionMenuToLast(listFields) {
        if (Array.isArray(listFields) && listFields.length > 0) {
            let maxOrder: any = 0;
            let configFieldIndex: any = false;
            for (let index = 0; index < listFields.length; index++) {
                var fields = listFields[index];
                if (fields.order != undefined && parseInt(fields.order) > maxOrder) {
                    maxOrder = parseInt(fields.order);
                }
                if (fields.config != undefined && fields.config.type == "ellipse") {
                    configFieldIndex = index;
                }
            }
            if (configFieldIndex) {
                listFields[configFieldIndex]["order"] = parseInt(maxOrder) + 1
            }
        }
        return listFields;
    }
    getHeaderList() {
        var allHeaderList = [];
        allHeaderList = [
            { name: "facility_sel", heading: "selfac" },
            { name: "external_website", heading: "ex_web" },
            { name: "care_type", heading: "care_type" },
            { name: "location_sel", heading: "pagename.list.location" },
            { name: "language_sel", heading: "langsel" },
            { name: "qms_sel", heading: "qmssel" },
            { name: "helpdesk_sel", heading: "helpdesk" },
            { name: "noty_sel", heading: "noty" },
            { name: "role_sel", heading: "rolsel" },
            { name: "url_update", heading: "button.update_landing_url" },
            { name: "support", heading: "button.support" },
            { name: "def_faclity", heading: "pagename.list.setDefaultFacility" },
            { name: "gen_pin", heading: "block.title.manage_user_pin" },
            { name: "change_loginid", heading: "pagename.add.login_id" },
            { name: "internet_speed", heading: "button.check_my_internet_speed" },
            { name: "shortcut", heading: "button.check_screen_shortcuts" },
            { name: "install_app", heading: "button.install_app" },
            { name: "ai_agent_dashboard", heading: "link.ai_agent_dashboard" }
        ];
        return allHeaderList;
    }
    getHeaderPreferences(callback) {
        var key = "main_header";
        var key1 = "main_menu";
        this.config.notAllowedHeaders = [];
        this.getUserPreferenceConfig([key, key1], (data) => {
            if (data["account__" + key] != undefined && Object.keys(data["account__" + key]).length > 0) {
                console.log('data["account__"+key]', data["account__" + key]);
                var afterConfig = this.applyJsonConfig({ headers: {} }, data["account__" + key]);
                console.log("afterConfig===>", afterConfig);
            } else {
                var afterConfig = this.applyJsonConfig({ headers: {} }, []);
            }

            if (data["account__" + key1] != undefined && Object.keys(data["account__" + key1]).length > 0) {
                console.log('data["account__"+key1]', data["account__" + key1]);
                var afterConfig = this.applyJsonConfig({ menus: {} }, data["account__" + key1]);
                console.log("afterConfig===>", afterConfig);
            }
            this.headerConfig.next(true);
            callback();
        });
    }
    getHeaderPreferencesPromise() {
        return new Promise((resolve, reject) => {
            this.getHeaderPreferences(() => {
                resolve(true);
            });
        });
    }

    filterHeadersComponent(allData, arr) {
        var notAllowedHeaders = this.config.notAllowedHeaders;
        if (Array.isArray(arr) && arr.length > 0) {
            notAllowedHeaders = notAllowedHeaders.concat(arr);
        }
        this.config.notAllowedHeaders = [...new Set(notAllowedHeaders)];
    }

    applyCareType(allData, arr) {
        var notAllowedCareType = [];
        if (Array.isArray(arr) && arr.length > 0) {
            notAllowedCareType = notAllowedCareType.concat(arr);
            var allCareType = this.appService.getUniversalConfig("care_type");
            var allowedCareType = [];
            for (let index = 0; index < allCareType.length; index++) {
                let element = allCareType[index];
                if (element.id != undefined && notAllowedCareType.indexOf(element.id) == -1) {
                    allowedCareType.push(element);
                }
            }
            this.config.allowedCareType = allowedCareType;
            this.appService.setCareType(this.config.allowedCareType);
            this.changeopdType(this.config.allowedCareType[0].id, () => {

            })
        }
    }

    isHeaderComponentAllowed(id) {
        try {
            return this.config.notAllowedHeaders.indexOf(id) == -1;
        } catch {
            return true;
        }
    }
    public changeopdType(event: any, callback) {
        let obj = { id: event }
        this.baseService.action(obj, 'add', 'account-management', 'change_care_type').subscribe(res => {
            if (res.errCode == 0) {
                callback(true)
            } else {
                this.alerts.error(res.message)
                callback(false)
            }
        });
    }

    loopMenuReverse(navItems, level, config) {
        for (let index = navItems.length - 1; index >= 0; index--) {
            var menu = navItems[index];
            var id = "";
            if (level == 0) {
                if (menu.menu_item_code != undefined) {
                    id = menu.menu_item_code;
                } else {
                    continue;
                }
            } else {
                if (menu.menu_item_code != undefined) {
                    id = menu.menu_item_code;
                } else {
                    continue;
                }
            }
            if (config.delete != undefined && config.menus != undefined && Array.isArray(config.menus)) {
                try {
                    if (id != "" && config.menus.filter(menu => (menu.id != undefined) && menu.id.includes(id)).length > 0) {
                        navItems.splice(index, 1);
                        continue;
                    }
                } catch (e) {
                    console.error("Error removing menu :" + id);
                    console.error(e)
                }

            }
            if (config.order != undefined && config.menus != undefined && Array.isArray(config.menus)) {
                let obj = config.menus.find(o => o.id == id);
                if (obj && obj.o != undefined) {
                    navItems[index]["order"] = obj.o;
                }
            }
            if (menu.children != undefined && Array.isArray(menu.children) && menu.children.length > 0) {
                this.loopMenuReverse(menu.children, level + 1, config);
                if (level <= 1) {
                    if (menu.children != undefined && Array.isArray(menu.children) && menu.children.length > 0) {
                        menu.children = menu.children.sort((a, b) => { return a.order - b.order });
                    }
                }
                if (menu.children != undefined && Array.isArray(menu.children) && menu.children.length == 0) {
                    navItems.splice(index, 1);//removing because all childrent is removed by hiding the menu
                    continue;
                }
            }
        }
        if (level == 0) {
            navItems = navItems.sort((a, b) => { return a.order - b.order });
        }
    }

    loopMenu(navItems, allActions, level) {
        for (let index = 0; index < navItems.length; index++) {
            var menu = navItems[index];
            var id = "";
            if (level == 0) {
                if (menu.user_friendly_name != undefined) {
                    id = menu.user_friendly_name;
                } else {
                    continue;
                }
            } else {
                if (menu.menu_item_code != undefined) {
                    id = menu.menu_item_code;
                } else {
                    continue;
                }
            }
            if (menu.name_translation_key != undefined) {
                var action = menu.name_translation_key ? menu.name_translation_key : menu.name;
                if (action.includes("menu.")) {
                    action = menu.name;
                }

                allActions.push({ heading: action, name: id, order: menu.order, level: level, mapKey: id });
                if (menu.children != undefined && Array.isArray(menu.children) && menu.children.length > 0) {
                    this.loopMenu(menu.children, allActions, level + 1);
                }
            } else {
                continue;
            }
        }
        return allActions;
    }

    getCommonConfig(callback) {
        var configKey = "common_config";
        this.getUserPreferenceConfig(configKey, (configData) => {
            this.commonConfig = configData;
            callback(configData);
        });
    }

    checkCommonConfigEnabled(key) {
        return (this.commonConfig[key] != undefined && this.commonConfig[key]);
    }

    currencyPattern() {
        let value: any = 3;
        if (this.appService._currentSessionData.currency_decimal_limit) {
            value = this.appService._currentSessionData.currency_decimal_limit
        }
        // if(this.appService.getAccountConfigValue('currency_decimal')){
        //   value = this.appService.getAccountConfigValue('currency_decimal')
        // }
        return "^[0-9]{1,11}(?:\.[0-9]{1," + value + "})?$"
    }

    saveCommonConfig(key, value) {
        var configKey = "common_config";
        this.commonConfig[key] = value;
        this.saveTableConfigData(configKey, this.commonConfig, () => { });
    }

    _saveCommonVoiceDetailsConfig(key, value, callback) {
        var configKey = "common_config";
        this.commonConfig[key] = value;
        this.saveTableConfigData(configKey, this.commonConfig, () => {
            callback()
        });
    }

    saveMenuConfig(obj, callback) {
        var configKey = "main_menu";
        this.getUserPreferenceConfig(configKey, (data) => {
            this.saveTableConfigData(configKey, { ...data, ...obj }, () => {
                callback();
            });
        });
    }

    isSmartMenuEnabled(key) {
        var configKey = "main_menu";
        var data: any = this.storageService.getLocalStorageDataSync(configKey);
        if (data) {
            return (data[key] != undefined) ? data[key] : false;
        } else {
            return true;
        }
    }
}